<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="content-txt">
      <div class="p22-2 animate-target" v-animate-in>Risk of CV mortality or end-stage renal disease in people with T2D and CKD<sup>*1,2</sup></div>
      <div ref="target" class="charts-img3 show_animation animate-target" v-animate-in>
        <img src="../../assets/images/p2-3/chart.png"/>
        <img src="../../assets/images/p2-3/line.png"/>
      </div>
      <div class="p22-3 animate-target" v-animate-in>UACR is now recognised by major guidelines as a treatment target<sup>3-5</sup></div>
      <div class="ct-img">
        <img class="animate-target" v-animate-in src="../../assets/images/p2-3/logo-element1.png"/>
        <img class="animate-target" v-animate-in src="../../assets/images/p2-3/logo-element2.png"/>
      </div>
    </div>
    <GoNext class="animate-target" v-animate-in href="/section2/2-4">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s2-1",
  components: {SectionTitle, GoNext, ContentNotice},
  data(){
    return {
      noticeTxt:"*Based on a meta-analysis of 1,024,977 people from the general population, high-risk CV, and CKD cohorts selected according to Chronic Kidney Disease Prognosis Consortium criteria.<br/><div class='brs'></div>"
      +"CKD, chronic kidney disease; CV, cardiovascular; T2D, type 2 diabetes; UACR, urine albumin-to-creatinine ratio.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Inoue K, <i>et al. Ann Epidemiol</i>. 2021;55:15-23. doi:10.1016/j.annepidem.2020.12.004.<br/>"
      +"2. Fox CS, <i>et al. Lancet</i>. 2012;380:166-173. doi:10.1016/S0140-6736(12)61350-6.<br/>"
      +"3. Kidney Health Australia. CKD Management in Primary Care handbook (5th edition). <a target='_blank' class='c-url' href='https://kidney.org.au/health-professionals/ckd-management-handbook'>https://kidney.org.au/health-professionals/ckd-management-handbook</a>.<br/>"
      +"4. RACGP. Management of type 2 diabetes: A handbook for general practice. <a target='_blank' class='c-url' href='https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx'>https://www.racgp.org.au/getattachment/7c05e922-ab1f-4301-aab7-f4f9b638cb66/Management-of-type-2-diabetes-A-handbook-for-general-practice.aspx</a>.<br/>"
      +"5. American Diabetes Association. Diabetes Care 2023;46(Suppl 1):S191–S202",
      title:"Persistent albuminuria (UACR) is associated with greater CV risk and renal risk in people with T2D and CKD<sup>1,2</sup>"
    }
  },
  computed:{

  },
  mounted() {
    this.initClassObserver();
  },
  beforeDestroy() {
    this.destroyObserver();
  },

  methods: {

    initClassObserver() {
      const targetEl = this.$refs.target;
      if (!targetEl) return;

      this.observer = new MutationObserver((mutations) => {
        console.log(mutations);
        const mutation = mutations[0];
        if (mutation.attributeName === 'class') {
          targetEl.children[1].classList.add('extend2')
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      };

      this.observer.observe(targetEl, config);
    },

    // 销毁观察者（避免内存泄漏）
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect(); // 断开监听
        this.observer = null; // 清空实例
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section2/s2.css";
.show_animation {
  position:relative;
}
.show_animation img:nth-child(2) {
  position:absolute;
  height: 100%;
  bottom:0px;
  left:0px;
  width:0%;
  object-fit: cover;
  object-position: left;
}
</style>
